export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode == 'dark';

  return {
    modalBody: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      width: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      maxWidth: {
        xs: '343px',
        sm: '90%',
        md: '760px',
      },
      height: '640px',
      maxHeight: '640px',
      minHeight: {
        xs: '640px',
        md: '640px',
      },
      p: '16px',
      bgcolor: theme?.palette?.background?.paper,
      borderRadius: '8px',
      boxShadow: isDark
        ? '0px 12px 36px rgba(0, 0, 0, 0.48)'
        : '0px 8px 32px rgba(0, 0, 0, 0.16)',
      boxSizing: 'border-box',
      overflow: 'hidden',
      outline: 'none',
      fontFamily: theme?.typography?.fontFamily,
    },
    modalHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    modalTitleWrapper: {
      flex: '1 1 auto',
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
    },
    modalTitle: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: '160%',
      letterSpacing: '0.15px',
      color: theme?.palette?.text?.primary,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
    },
    modalClose: {
      color: isDark ? '#FFFFFF8F' : theme?.palette?.grey?.[500],
      flexShrink: 0,
      mt: '-0.3rem',
      mr: '-0.5rem',
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    materialRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      height: '64px',
      px: '12px',
      py: {
        xs: '4px',
        md: '12px',
      },
      borderRadius: '8px',
      border: `1px solid ${isDark ? '#FFFFFF1A' : '#231F2929'}`,
      backgroundColor: isDark ? '#231F29' : '#F8F7F9',
      boxSizing: 'border-box',
    },
    materialDetails: {
      display: 'flex',
      flex: '1',
      alignItems: {
        xs: 'start',
        md: 'center',
      },
      justifyContent: 'space-between',
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      gap: {
        xs: '2px',
        md: '8px',
      },
    },
    materialIcon: {
      height: '40px',
      width: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    titleWrapper: {
      flex: '1',
      minWidth: 0,
      display: 'flex',
      alignItems: 'center',
    },
    title: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '150%',
      letterSpacing: '0.15px',
      color: isDark ? '#FFFFFF' : '#000000DE',
      flex: '1 1 auto',
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: 2,
      wordBreak: 'break-word',
    },
    lastEdited: {
      fontSize: '12px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
    goToPageButton: {
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'row',
      gap: '8px',
      fontSize: '13px',
      fontWeight: 500,
      color: theme?.palette?.primary?.main,
      alignItems: 'center',
      padding: {
        xs: '0px 0px',
        md: '5px 8px',
      },
      maxWidth: 'fit-content',
      '&:hover': {
        md: {
          backgroundColor: theme?.palette.action.hover,
          borderRadius: '4px',
        },
      },
    },
  };
};
